import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../contents/redux/actions/authActions";
import {
  MenuRounded,
  NotificationsOutlined,
  ArrowDropDownCircleOutlined,
  Person,
  AdminPanelSettings,
  LogoutSharp,
} from "@mui/icons-material";
import Avatar from "../../images/avatar.png";
import styles from "../utilities/cssmodules/Topbar.module.css";

const TopbarContent = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showAccountOptions, setShowAccountOptions] = useState(false);
  const [loggedInUserName, setLoggedInUserName] = useState("");
  const [loggedInUserBusinessName, setLoggedInUserBusinessName] = useState("");
  const [loggedInUserRole, setLoggedInUserRole] = useState("");

  const toggleAccountOptions = () => {
    setShowAccountOptions((prev) => !prev);
  };

  const handleNotificationsRoute = () => {
    navigate("/notifications");
    setShowAccountOptions(false);
  };

  const handleProfileRoute = () => {
    navigate("/profile");
    setShowAccountOptions(false);
  };

  const handleChangePasswordRoute = () => {
    navigate("/changepassword");
    setShowAccountOptions(false);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
    navigate("/");
  };

  const handleMenuIconClick = () => {
    console.log("Menu icon clicked, calling toggleSidebar");
    toggleSidebar();
  };

  // useEffect(() => {
  //   const storedLoggedInUserName = localStorage.getItem(
  //     "loggedInUserFirstName",
  //   );
  //   if (storedLoggedInUserName) {
  //     setLoggedInUserName(storedLoggedInUserName);
  //   }
  //   const storedLoggedInUserRole = localStorage.getItem("loggedInUserRole");
  //   if (storedLoggedInUserRole) {
  //     setLoggedInUserRole(storedLoggedInUserRole);
  //   }
  //   const storedLoggedInUserBusinessName = localStorage.getItem("loggedInUserBusinessName");
  //   if (storedLoggedInUserBusinessName) {
  //     setLoggedInUserBusinessName(storedLoggedInUserBusinessName);
  //   }
  // }, []);


  useEffect(() => {
    const storedName = localStorage.getItem("loggedInUserFirstName");
    if (storedName && storedName !== "null" && storedName !== "undefined") {
      setLoggedInUserName(storedName);
    }

    const storedRole = localStorage.getItem("loggedInUserRole");
    if (storedRole && storedRole !== "null" && storedRole !== "undefined") {
      setLoggedInUserRole(storedRole);
    }

    const storedBusinessName = localStorage.getItem("loggedInUserBusinessName");
    if (
      storedBusinessName &&
      storedBusinessName !== "null" &&
      storedBusinessName !== "undefined" &&
      storedBusinessName.trim() !== ""
    ) {
      setLoggedInUserBusinessName(storedBusinessName);
    }
  }, []);


  return (
    <div className={styles["topbar-content"]}>
      <div
        className={styles["mobile-menu-icon"]}
        onClick={handleMenuIconClick}
        aria-label="Toggle sidebar"
      >
        <MenuRounded />
      </div>
      <div className={styles["topbar-right-items"]}>
        <div
          className={styles["topbar-notifications-box"]}
          onClick={handleNotificationsRoute}
        >
          <div className={styles["topbar-notification-count"]}>14</div>
          <div className={styles["topbar-notification-icon"]}>
            <NotificationsOutlined />
          </div>
        </div>

        <div
          className={styles["topbar-user-box"]}
          onClick={toggleAccountOptions}
        >
          <div className={styles["topbar-user-profile-avatar"]}>
            <img src={Avatar} alt="userimage" />
          </div>
          <div className={styles["topbar-user-credentials"]}>
            <div className={styles["topbar-username"]}>{loggedInUserBusinessName || loggedInUserName}</div>
            <div className={styles["topbar-user-role"]}>{loggedInUserRole}</div>
          </div>
          <div className={styles["topbar-user-dropdown-btn"]}>
            <ArrowDropDownCircleOutlined />
          </div>
        </div>
      </div>

      <div
        className={`${styles["topbar-user-account-options-container"]} ${showAccountOptions ? styles.active : ""}`}
      >
        <div
          className={styles["topbar-user-account-options-user-info-wrapper"]}
        >
          <div className={styles["topbar-user-account-options-user-image"]}>
            <img src={Avatar} alt="userimage" />
          </div>
          <div className={styles["topbar-user-account-options-user-info"]}>
            <div className={styles["topbar-user-account-options-user-name"]}>
              {loggedInUserName || loggedInUserBusinessName}
            </div>
            <div className={styles["topbar-user-account-options-user-role"]}>
              {loggedInUserRole}
            </div>
          </div>
        </div>

        <div className={styles["topbar-user-account-options-menu"]}>
          <div
            className={styles["topbar-user-account-options-menu-item"]}
            onClick={handleProfileRoute}
          >
            <span>
              <Person />
            </span>
            Profile
          </div>
          <div
            className={styles["topbar-user-account-options-menu-item"]}
            onClick={handleChangePasswordRoute}
          >
            <span>
              <AdminPanelSettings />
            </span>
            Change password
          </div>
        </div>

        <div className={styles["topbar-user-account-options-logout-wrapper"]}>
          <div
            className={styles["topbar-user-account-options-logout"]}
            onClick={handleLogout}
          >
            <span>
              <LogoutSharp />
            </span>
            Log out
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopbarContent;
